<template>
    <RichResponseListItem
        :title="renderSet.title"
        :icon="renderSet.icon"
        :icon-type="renderSet.iconType"
        v-model="model"
        :class="renderSet.className"
        :image="renderSet.image"
        :selectable="selectable"
    >
        <ion-chip
            class="small"
            v-if="renderSet.tags"
            v-for="tag in renderSet.tags"
        >
            {{ tag }}
        </ion-chip>

        <span v-html="renderSet.text"></span>
    </RichResponseListItem>
</template>

<script setup lang="ts">
import RichResponseListItem from "./RichResponseListItem.vue"
import datetime from "@/helper/datetime/datetime"
import {IonChip} from '@ionic/vue'
import {computed, PropType} from "vue"
import {Day, DemandJoDaShTi} from "@/graphql/generated/graphql"
import {kapitelDateString} from "@/graphql/kapitelTypes"
import {
    additionalAvailabilitySummaryLabel,
    availabilityEffectiveTimesHumanReadable, getAvailabilityLabels,
    getAvailabilitySummary,
    hasAdditionalAvailabilities,
    hasShifts,
    hasShiftsOrAAs
} from "@/helper/availability"
import {getLabelForAbsenceType} from "@/helper/absence"
import {getImageForJobsite} from '@/helper/jobsite'

const model = defineModel()

const props = defineProps({
    date: {
        type: String as PropType<kapitelDateString>,
        required: true
    },
    dayData: {
        type: Object as PropType<Day>,
        required: false
    },
    routing: {
        type: Boolean,
        required: false,
        default: false
    },
    selectable: {
        type: Boolean,
        required: false,
        default: false
    },
    showIcon: {
        type: Boolean,
        required: false,
        default: true
    }
})

const renderSet = computed(() => {
    const result = {
        title: ' ',
        text: ' ',
        tags: [] as string[],
        className: '',
        icon: props.date as string,
        iconType: 'date' as string | null,
        image: undefined as string | undefined
    }

    if (props.dayData?.booking) {
        const begin = datetime.formatKapitelDateTime(props.dayData.booking.begin, datetime.kapitelDateTimeFormatTime)
        const until = datetime.formatKapitelDateTime(props.dayData.booking.until, datetime.kapitelDateTimeFormatTime)

        result.className = 'booking'
        result.title = 'Dienst: ' + props.dayData.booking.jobsite.abbreviation
        result.text = `${begin} - ${until} Uhr`
        result.tags = [props.dayData.booking.shiftType]
        result.image = getImageForJobsite(props.dayData.booking.jobsite)

    } else if (props.dayData?.absence) {

        const absenceTypeLabel = getLabelForAbsenceType(props.dayData.absence.type)

        result.className = 'absence'
        result.title = 'nicht verfügbar'
        result.tags = [absenceTypeLabel]

    } else if (props.dayData?.availability && hasShiftsOrAAs(props.dayData?.availability)) {

        const summary = getAvailabilitySummary([props.dayData.availability])
        const shiftTimes = availabilityEffectiveTimesHumanReadable(props.dayData.availability)
        const labels = getAvailabilityLabels(props.dayData.availability)

        result.className = 'availability'
        result.title = labels.label
        result.text = shiftTimes || result.text
        result.tags = summary.shiftTypesList as string[]

        if (labels.hasShiftsAndAdditionalAvailabilities) {
            result.title += '<br>'
        } else {
            result.title += ' '
        }

        result.title += labels.additionalAvailabilitySummary

    } else {
        result.text = 'Keine Verfügbarkeiten'
    }



    if(!props.showIcon) {
        result.iconType = null
    }else{
        result.iconType = 'date'
    }


    return result
})
</script>

<style scoped lang="scss">

ion-chip {
    transform: translateY(0.15em);
    flex: 0 0 auto;
}

.booking {
    ion-chip {
        background-color:var(--ion-color-black-tint);
        color: var(--ion-color-white);
    }
}

.availability {
    ion-chip {
        background-color:var(--ion-color-green);
        color: var(--ion-color-white);
    }
}

.absence {
    ion-chip {
        background-color:var(--ion-color-red);
        color: var(--ion-color-white);
    }
}
</style>
